export namespace ErrorCode {
  export enum BadRequest {
    PasswordReinitializationTokenExpired = 3001,
    PasswordReinitializationTokenBadFormatted = 3002,
    PasswordNeedToBeDifferent = 3003,
    RefreshTokenInvalid = 3006,
    LoginAlreadyExisting = 3007,
    InvalidPassword = 3009,
    InvalidNaming = 3010,

    CannotUpdateDocumentWithBadInformations = 3100,
    CannotAddFragmentToClosedDocument = 3101,
    MaximumSubscriptionAgencyFileUpload = 3102,
    CannotUpdateDocument = 3103,
    CannotUnarchiveAgencyWithSignedContract = 3104,
    InvalidForm = 3105,
    AgencyNotDeletable = 3106,

    CannotGenerateInvalidContract = 3200,
    InvalidIban = 3201,
    CannotAccessQuotationPayment = 3301,
    QuotationPayment = 3302,
    QuotationSubscription = 3303,
    CannotActivatePolicy = 3304,
    CannotUpdateActivatedPolicy = 3305,
    PolicyWithoutPricing = 3306,
    CannotUpdatePolicyWithComplement = 3307,
    ComplementAlreadyPaid = 3308,
    CannotDeleteComplementWithRunningTransaction = 3309,
    ReceiptBadStatusException = 3310,
    QuotationHasPaymentInProgress = 3311,
    PolicyNotSuspendable = 3312,
    PolicyNotTerminatable = 3313,
    CannotPayTerminatedPolicy = 3314,
    PolicyNotRenewable = 3315,
    AvenantDisabledInRenewPeriod = 3316,
    RequestAlreadyRequested = 3317,
    RequestHasOneRunningTransaction = 3318,
    MissingImmatriculationFromQuotation = 3319,
    InvalidRefundType = 3320,
    InvalidActionType = 3321,
    InvalidReceiptType = 3322,
    ReceiptPaymentDateDelayNotPassed = 3323,
    ReceiptAmountIsTooLow = 3324,
    ReceiptCreationDateIsIsNotHandled = 3325,
    InvalidInsuranceType = 3326,
    MissingAgencyParameter = 3327,
    MissingBrokerId = 3328,
    CannotArchiveMainBroker = 3329,
    WithholdingThresholdExceeded = 3330,
    MissingSignedPropositionFiles = 3331,
    MissingQuotationPublicId = 3332,
    UploadedFileBadExtension = 3333,
    MissingCommissionType = 3334,
    InvalidBrokerLoading = 3335,
    LastStateIsNotTermination = 3336,
    InsuranceTypeInvalidForNppTermination = 3337,
    TerminationNotNpp = 3338,
    TerminationMoreThanTwoMonthsOld = 3339,
    InvalidPaymentOrderToken = 3340,
    PaymentOrderExpired = 3341,
    PaymentOrderAlreadyPaid = 3342,
    PaymentOrderHasInvalidReceipt = 3343,
    RemiseEnVigeurImpossible = 3507,

    RejectActionAlreadyExecuted = 3401,
    CannotGenerateReleveInformationForPolicyState = 3402,
    HealthRejectFileAlreadyHandled = 3403,

    CarInsurance_FinGarantieProvisoire_EndDateOutOfRange = 3501,

    HealthInsurance_InvalidSSNumber = 4001,
    HealthInsurance_InvalidOrganismNumber = 4002,
    HealthInsurance_MissingMembershipApplication = 4003,
    HealthInsurance_FrancaisOrTnsOnly = 4004,
    HealthInsurance_InvalidSalesman = 4005,
    HealthInsurance_CannotUseEcoOptionWithFormula1 = 4006,
    HealthInsurance_FranceOrCorsicaOnly = 4007,
    HealthInsurance_MinimumAge18 = 4008,
    HealthInsurance_MaximumAge85 = 4009,
    HealthInsurance_CityInvalidValue = 4010,
    HealthInsurance_CityNotFound = 4011,
    HealthInsurance_InvalidNumberOfChildren = 4012,
    HealthInsurance_EffectDateMustBeInFuture = 4013,
    HealthInsurance_InvalidEmailDomain = 4014,
    HealthInsurance_IBANInvalidKey = 4015,
    HealthInsurance_IBANClosedBankAccount = 4016,
    HealthInsurance_IBANAlphanumericCharOnly = 4017,
    HealthInsurance_BICInvalidLength = 4018,
    HealthInsurance_MaritalStatus = 4019,
    HealthInsurance_InvalidCityAndZipCode = 4020,
    HealthInsurance_SalesmanNotActivated = 4021,

    AgeoAccountDoesNotExist = 4101,
    HealthDirectDebitAlreadyHandled = 4102,
    HealthDirectDebitUploadAlreadyHandled = 4103,
    AgeoSubscriptionException = 4104,
    AgeoContractRefDoesNotExist = 4105,
    CouldntParseAgeoResult = 4106,
    AgeoContractExistsWithAnotherSubscriberName = 4107,

    ErrorWhileCallingAagSignature = 50001,
    QuotationSmsNotHandled = 50002,
  }

  export enum NotFound {
    City = 2001,
    Account = 2002,
    Agency = 2003,
    Document = 2004,
    File = 2005,
    Job = 2006,
    Manager = 2007,
    EmailMessage = 2008,
    BuiltInRole = 2009,
    RefreshToken = 2010,
    Fragment = 2011,
    EloquantAccount = 2012,
    AgencyEmailMessage = 2013,
    Quotation = 2014,
    PaymentTransaction = 2015,
    Client = 2016,
    Policy = 2017,
    Blob = 2018,
    Broker = 2019,
    Risk = 2020,
    Complement = 2021,
  }

  export enum InvalidSSNumberReasons {
    InvalidLength = 1,
    InvalidFirstCharacter,
    Invalid4And5Characters,
    Invalid6And7Characters,
    MismatchSexe,
    MismatchBirthdayMonth,
    MismatchBirthdayYear,
  }

  export const Forbidden = 4000;
  export const Quotation = 5000;
}
